<template>
    <v-main class="py-12 blockCaptionWithText" :style="mainStyle">
        <section class="m-auto" :style="sectionStyle">
            <v-row v-if="title" align="center" justify="center" no-gutters class="text-center grey--text text--darken-4">
                <v-col align="center" cols="12">
                    <h3 :class="txtClass" :style="titleStyle" v-html="title"></h3>
                </v-col>
            </v-row>
            <v-row v-if="subTitle" align="center" justify="center" no-gutters class="text-center grey--text text--darken-4">
                <v-col align="center" cols="12">
                    <h3 :class="txtClass" :style="subTitleStyle" v-html="subTitle"></h3>
                </v-col>
            </v-row>
            <v-row v-if="hasDefaultSlot" align="center" justify="center" no-gutters class="text-center grey--text text--darken-2">
                <v-col cols="12" class="title font-weight-light pt-5 pb-8">
                    <slot></slot>
                </v-col>
            </v-row>
        </section>
    </v-main>
</template>

<script>
    import {layoutMixin} from '@/utils/layout-mixin'
    export default {
        mixins:[layoutMixin],
        props: {
            title: {
                type: String,
                default: null
            },
            subTitle: {
                type: String,
                default: null
            },
            txtClass:{
                type:String
            },
            fontSize:{
                type: String,
                default: "8em"
            },
            scale: {
                type: Number,
                default: 0.8
            },
            disableScale:{
                type:Boolean,
                default:false
            },
            maxWidth:{
                type:String,
                default:"800px"
            }
        },
        computed:{
            titleStyle(){
                return {
                    'font-size':this.fontSize,
                    'font-weight':700,
                    'letter-spacing':'0.06em',
                    'line-height':this.isMdAndUpDevice?'100px':'1.5em'
                }
            },
            subTitleStyle(){
                return {
                    'font-size':this.fontSize,
                    'font-weight':700,
                    'line-height':this.isMdAndUpDevice?'1.2em':'1.5em'
                }
            },
            mainStyle(){
                return (this.disableScale)?{}:{
                    'min-height':`${this.sectionHeight}px`
                }
            },
            sectionStyle(){
                return {
                    'max-width':this.maxWidth
                }
            },
            sectionHeight(){
                return (this.scale*this.bgHeight);
            },
            hasDefaultSlot () {
                return !!this.$slots.default
            },
        },
        data() {
            return {
                
            }
        },
    }
</script>

<style lang="scss">
    .blockCaptionWithText .v-main__wrap{
        margin:auto;
    }
</style>
